import WhmcsApi from "../../WhmcsApi";

export const applyPaySaF = async ({ invoiceId, token, callbackError = () => {} }) => {
  try {
    const whmcsApi = new WhmcsApi(); // Create instance of WhmcsApi
    const response = await whmcsApi.request("applyPaySaF", { invoiceId }, "POST", token);

    return response;
  } catch (error) {
    console.error("Failed Apply pay:", error);
    callbackError();
    return false;
  }
};
